import { PreloaderHelper } from "shared/helpers";
import { DPContentConfig } from "shared/config";

export class DiscountPopupService {
    public static show(isNeedToOpenMain = true, isLeaderBoard = false): void {        
        const disount = document.getElementById('discount_popup');
        disount.style.display = 'flex';

        const closeBtn = document.getElementById('close_DP');
        closeBtn.addEventListener('click', () => {
            this.hide(isNeedToOpenMain, isLeaderBoard);
        })

        this.addData();
    }

    public static hide(isNeedToOpenMain, isLeaderBoard = false): void {
        const disount = document.getElementById('discount_popup');
        disount.style.display = 'none';

        if (isNeedToOpenMain) {
            const main = document.getElementById('main_page');
            main.style.display = 'flex';
        }
        
        if (isLeaderBoard) {                     
            const leaderboard = document.getElementById('leaderboard');
            leaderboard.style.display = 'flex';
        }

        const oldCloseBtn = document.getElementById('close_DP');
        const newCloseBtn = oldCloseBtn.cloneNode(true);
        oldCloseBtn.parentNode.replaceChild(newCloseBtn, oldCloseBtn);
    }

    private static addData() {
        const content = document.getElementById('DP_content');
        const products = DPContentConfig.products;

        for (let i = 0; i < products.length; i++) {
            const product = products[i];

            const li = document.createElement('li');
            const img = document.createElement('img');
            const div = document.createElement('div');
            const h3 = document.createElement('h3');
            const span = document.createElement('span');
            const button = document.createElement('button');

            img.draggable = false;
            img.classList.add('discount_img');
            img.src = `./assets/img/${product.img}`;

            div.classList.add('discount_info');
            button.classList.add('collect');
            h3.textContent = product.title;
            span.textContent = `Discount: ${product.discount}%`;
            button.textContent = 'pick up';

            div.appendChild(h3);
            div.appendChild(span);
            li.appendChild(img);
            li.appendChild(div);
            li.appendChild(button);
            content.appendChild(li);
        }

        setTimeout(() => {
            PreloaderHelper.togglePreloader(false);
        }, 1000)
    }
}